import {Component} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-login-form',
  templateUrl: './login.component.html'
})
export class LoginComponent {
  username: string;
  password: string;
  loginError = false;

  constructor(private authService: AuthService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  login() {
    this.loginError = false;
    const redirectUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.authService
      .login(this.username, this.password)
      .subscribe(
        _ => this.router.navigateByUrl(redirectUrl),
        _ => this.showLoginError()
      );
  }

  private showLoginError() {
    this.loginError = true;
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/components/auth/login/login.component.ts